import geolib from 'geolib';

const getDistance = (a, b) => a.lat && a.lng && b.lat && b.lng && Math.round(
  geolib.getDistance({latitude: a.lat, longitude: a.lng}, {latitude: b.lat, longitude: b.lng}) / 1609.34
);

export {
  getDistance,
};



// WEBPACK FOOTER //
// ./src/misc/geo.js